import { createContext, useState } from 'react';
import { Drawer } from 'vaul';

export const BottomSheetContext = createContext(false);

export const BottomSheet = ({
  isOpen,
  onClose,
  content,
  fullContent,
  onSnapChange,
  snapPoints = [0.28, 0.95],
}) => {
  const [activeSnap, setActiveSnap] = useState(snapPoints[0]);

  const handleSnapChange = snap => {
    setActiveSnap(snap);
    if (onSnapChange) onSnapChange(snap);
  };

  const isFull = activeSnap === snapPoints[snapPoints.length - 1];

  return (
    <Drawer.Root
      open={isOpen}
      onOpenChange={open => {
        if (!open) onClose();
      }}
      snapPoints={snapPoints}
      activeSnapPoint={activeSnap}
      setActiveSnapPoint={handleSnapChange}
      modal={false}
    >
      <Drawer.Portal>
        <Drawer.Overlay
          className={`fixed inset-0 z-[9998] transition-opacity ${
            isFull
              ? 'bg-black/40 pointer-events-auto'
              : 'bg-transparent pointer-events-none'
          }`}
        />
        <Drawer.Content className="fixed inset-x-0 bottom-0 z-[9999] bg-white rounded-t-2xl shadow-xl flex flex-col outline-none h-full max-h-[97vh]">
          <Drawer.Title className="sr-only">Realty details</Drawer.Title>
          <Drawer.Description className="sr-only">
            Selected realty preview
          </Drawer.Description>

          <div className="flex justify-center pt-2 pb-1 shrink-0">
            <div className="h-1 w-10 rounded-full bg-gray-300" />
          </div>

          <div className="overflow-y-auto pb-[env(safe-area-inset-bottom)] flex-1">
            <BottomSheetContext.Provider value={true}>
              {isFull && fullContent ? fullContent : content}
            </BottomSheetContext.Provider>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};
